






















































































































import Vue from "vue";
import { Component } from "vue-property-decorator";
import {
    Button,
    Container,
    Dialog,
    Form,
    FormItem,
    Icon,
    Input,
    InputNumber,
    Message,
    Option,
    Popconfirm,
    Select,
    Table,
    TableColumn,
} from "element-ui";
import { Getter } from "vuex-class";
import Transfer from "@/components/Transfer/Transfer.vue";
import AddDebt from "@/components/Debt/AddDebt.vue";
import { axiosInstance } from "@/utils/axios";

Vue.use(Container);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Button);
Vue.use(Popconfirm);
Vue.use(Icon);
Vue.use(Dialog);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Input);
Vue.use(Select);
Vue.use(Option);
Vue.use(InputNumber);
Vue.use(Popconfirm);

@Component({
    name: "app-receivers",
    components: {
        Transfer,
        AddDebt,
    },
})
export default class ReceiversPage extends Vue {
    dialogFormVisible = false;
    accountNumber = "";
    name = "";
    bankType = "";
    labelWidth = "150px";
    disableUpdateInput = false;
    titleDialog = "ADD NEW RECEIVER";
    index = -1;
    id = -1;
    dialogTransferVisible = false;

    addTransAccountNumber = "";
    addTransName = "";
    addTransBankType = "";
    isChoose = false;

    isLoading = false;

    dialogDebtVisible = false;
    addDebtAccountNumber = "";
    addDebtName = "";

    form = {
        name: "",
        bankType: "",
        accountNumber: "",
    };
    @Getter("receiver/data") data!: any;

    closeTransfer() {
        this.dialogTransferVisible = false;
        this.addTransAccountNumber = "";
        this.addTransName = "";
        this.addTransBankType = "";
        this.isChoose = false;
    }

    closeAddDebt() {
        this.dialogDebtVisible = false;
        this.addDebtAccountNumber = "";
        this.addTransName = "";
        this.isChoose = false;
    }

    closeForm() {
        this.titleDialog = "ADD NEW RECEIVER";
        this.dialogFormVisible = false;
        this.form.name = "";
        this.form.accountNumber = "";
        this.form.bankType = "";
        this.disableUpdateInput = false;
        this.isLoading = false;
    }

    handleCreateDebt(row: any) {
        this.addDebtAccountNumber = row.desAccountNumber;
        this.addDebtName = row.name;
        this.isChoose = true;
        this.dialogDebtVisible = true;
    }

    async handleSend(row: any) {
        this.addTransAccountNumber = row.desAccountNumber;
        this.addTransName = row.name;
        this.addTransBankType = row.bankType;
        this.isChoose = true;
        this.dialogTransferVisible = true;
    }

    async handleEdit(row: any) {
        this.titleDialog = "UPDATE RECEIVER";
        this.disableUpdateInput = true;
        this.dialogFormVisible = true;
        this.form.name = row.name;
        this.form.accountNumber = row.desAccountNumber;
        this.form.bankType = row.bankType;
        this.index = this.data.indexOf(row);
        this.id = row.id;
    }

    async getName() {
        try {
            this.isLoading = true;
            if (this.form.bankType === "LOCAL") {
                const { data: data } = await axiosInstance.get(
                    "user/profile/account-number?number=" +
                        this.form.accountNumber,
                );
                if (!data) {
                    Message({
                        showClose: true,
                        message: "Cant find account number",
                        type: "error",
                    });
                }
                this.form.name = data.name;
            }
            if (this.form.bankType === "PGP") {
                const { data: data } = await axiosInstance.get(
                    "transaction/interbank/info",
                    {
                        params: {
                            accountNumber: this.form.accountNumber,
                            bankType: "PGP",
                        },
                    },
                );
                if (data.success === false) {
                    Message({
                        showClose: true,
                        message: data.message,
                        type: "error",
                    });
                }
                this.form.name = data.data;
            }

            if (this.form.bankType === "RSA") {
                const { data: data } = await axiosInstance.get(
                    "transaction/interbank/info",
                    {
                        params: {
                            accountNumber: this.form.accountNumber,
                            bankType: "RSA",
                        },
                    },
                );
                if (data.success === false) {
                    Message({
                        showClose: true,
                        message: data.message,
                        type: "error",
                    });
                }
                this.form.name = data.payload.userName;
            }
        } catch (e) {
            Message({
                showClose: true,
                message: e,
                type: "error",
            });
        } finally {
            this.isLoading = false;
        }
    }
    async handleDelete(row: any) {
        try {
            await this.$store.dispatch("receiver/deleteReceiver", {
                id: row.id,
                index: this.data.indexOf(row),
            });
            Message({
                showClose: true,
                message: "Delete receiver successful",
                type: "success",
            });
        } catch (e) {
            Message({
                showClose: true,
                message: e,
                type: "error",
            });
        }
    }

    async submitForm() {
        if (!this.disableUpdateInput) {
            try {
                this.isLoading = true;
                await this.$store.dispatch("receiver/addReceiver", {
                    desAccountNumber: this.form.accountNumber,
                    name: this.form.name,
                    bankType: this.form.bankType,
                });
                this.closeForm();
                Message({
                    showClose: true,
                    message: "Add new receiver successful",
                    type: "success",
                });
            } catch (e) {
                console.log(e);
                Message({
                    showClose: true,
                    message: e,
                    type: "error",
                });
            } finally {
                this.isLoading = false;
            }
        } else {
            try {
                this.isLoading = true;
                await this.$store.dispatch("receiver/updateReceiver", {
                    id: this.id,
                    desAccountNumber: this.form.accountNumber,
                    name: this.form.name,
                    bankType: this.form.bankType,
                    index: this.index,
                });
                Message({
                    showClose: true,
                    message: "Update receiver successful",
                    type: "success",
                });
                this.closeForm();
            } catch (e) {
                console.log({ error: e });
                Message({
                    showClose: true,
                    message: e,
                    type: "error",
                });
            } finally {
                this.isLoading = false;
            }
        }
    }

    mounted() {
        this.$store.dispatch("receiver/loadReceiverList");
    }
}
